import { useEffect, useState } from 'react';

export default function Auth({ kind, token }) {
  const [status, setStatus] = useState(kind === 'confirm' ? 'loading' : 'ready');
  const [message, setMessage] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
    if (kind !== 'confirm') return;
    fetch('/api/confirm/' + encodeURIComponent(token))
      .then((r) => r.text())
      .then((t) => { setStatus('done'); setMessage(t); })
      .catch(() => { setStatus('done'); setMessage('Error al confirmar'); });
  }, [kind, token]);

  async function doReset() {
    if (!password) return;
    try {
      const res = await fetch('/api/reset', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const d = await res.json();
      setMessage(d.ok ? 'Contraseña actualizada. Ya puedes iniciar sesión.' : (d.error || 'Error'));
    } catch (e) { setMessage('Error de red'); }
  }

  return (
    <div className="app login-wrap">
      <div className="card login-card">
        <div className="brand brand-center">
          <span className="logo-text">Buyubampo</span>
        </div>
        {kind === 'confirm' ? (
          <p style={{ textAlign: 'center' }}>{status === 'loading' ? 'Confirmando...' : message}</p>
        ) : (
          <>
            <p className="dim" style={{ margin: 0 }}>Escribe tu nueva contraseña.</p>
            <input type="password" placeholder="Nueva contraseña" value={password} onChange={(e) => setPassword(e.target.value)} />
            <button className="login-submit" onClick={doReset}>Restablecer contraseña</button>
            {message && <div className="reg-msg ok">{message}</div>}
          </>
        )}
        <a href="/" className="link-btn" style={{ textAlign: 'center' }}>Ir al inicio de sesión</a>
      </div>
    </div>
  );
}
